import ConversationReflection from "../model/ConversationReflection";

export default class NewConversationReflectionMessagesEvent {
    /**
     * @constructor
     * @param {ConversationReflection} conversation 
     * @param {ConversationReflectionMessage[]} messages 
     */
    constructor(conversation, messages) {
        this._type = NewConversationReflectionMessagesEvent.TYPE;

        this._conversation = conversation;
        this._messages = messages;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }

    get messages() {
        return this._messages;
    }
}

NewConversationReflectionMessagesEvent.TYPE = "NewConversationReflectionMessagesEvent.TYPE";